import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-live-broadcast',
  templateUrl: './live-broadcast.component.html',
  styleUrls: ['./live-broadcast.component.css']
})
export class LiveBroadcastComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;
  
  constructor() { }

  ngOnInit(): void {
  }

  requestData = `
  ffmpeg -loglevel verbose -stream_loop -1 -re -i pride.mp4 -c:v libx264 -preset veryfast -strict -2 -c:a aac -ac 2 -ar 44100 -f flv "rtmp://norm-pri-c1-s1-us-east-1.cmw.optimus.optimusdrive.ai:8000/input/ef0556cf-d62d-4ee6-90fb-3437cd972e89 live=1 buffer=5000000" 
  `

  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
        this.copyButton = false;
        this.copiedButton = true;
        // After a few seconds, reset the button states
        setTimeout(() => {
          this.copyButton = true;
          this.copiedButton = false;
        }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.requestData);
  }

}
